import { render, staticRenderFns } from "./LocationShowContainer.vue?vue&type=template&id=8c2dd95c&scoped=true&"
import script from "./LocationShowContainer.vue?vue&type=script&lang=ts&"
export * from "./LocationShowContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2dd95c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
